module.exports = __webpack_public_path__ + "files/4425d6fa1e803beb057b441af69758ad.png";